import React, { createContext, useContext, useState } from 'react';
import { LocalCategoryModel } from '../models';

interface CategoryContextType {
  selectedCategory: LocalCategoryModel | null;
  setSelectedCategory: (category: LocalCategoryModel | null) => void;
}

const CategoryContext = createContext<CategoryContextType | undefined>(undefined);

export const CategoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState<LocalCategoryModel | null>(null);

  return (
    <CategoryContext.Provider value={{
      selectedCategory,
      setSelectedCategory
    }}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategory = (): CategoryContextType => {
  const context = useContext(CategoryContext);
  if (!context) {
    throw new Error('useCategory must be used within a CategoryProvider');
  }
  return context;
};
